import React, { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import MediaFilesLibrary from '../../MediaFilesLibrary'

import { getFacebookMediaVideos, clearFacebookMediaVideos } from '../../../../modules/actions/mediaFiles'
import {
  facebookVideoPreviewsAfterSelector,
  facebookVideoPreviewsErrorSelector,
  facebookVideoPreviewsIsLoadingSelector,
  facebookVideoPreviewsNextSelector,
  facebookVideoPreviewsSelector,
  facebookVideoPreviewsWasLoadedSelector
} from '../../../../modules/selectors/mediaFiles'
import { selectedFacebookAdAccountSelector } from '../../../../modules/selectors/adAccounts'

const FacebookVideoFilesLibrary = props => {
  const dispatch = useDispatch()

  const { id: selectedAdAccountId } = useSelector(selectedFacebookAdAccountSelector)
  const afterVideos = useSelector(facebookVideoPreviewsAfterSelector)

  const loadInitialMediaHandler = useCallback(() => {
    dispatch(
      getFacebookMediaVideos({
        account: selectedAdAccountId,
        limit: 12
      })
    )
  }, [dispatch, selectedAdAccountId])

  const loadMoreHandler = useCallback(() => {
    dispatch(
      getFacebookMediaVideos({
        account: selectedAdAccountId,
        limit: 12,
        after: afterVideos
      })
    )
  }, [dispatch, selectedAdAccountId, afterVideos])

  const clearVideosHandler = useCallback(() => {
    dispatch(clearFacebookMediaVideos())
  }, [dispatch])

  return (
    <MediaFilesLibrary
      type="video"
      mediaThumbnailFieldName="picture"
      mediaFilesSelector={facebookVideoPreviewsSelector}
      mediaFilesIsLoadingSelector={facebookVideoPreviewsIsLoadingSelector}
      mediaFilesErrorSelector={facebookVideoPreviewsErrorSelector}
      mediaFilesWasLoadedSelector={facebookVideoPreviewsWasLoadedSelector}
      mediaFilesNextSelector={facebookVideoPreviewsNextSelector}
      loadInitialMediaHandler={loadInitialMediaHandler}
      loadMoreHandler={loadMoreHandler}
      clearMediaHandler={clearVideosHandler}
      {...props}
    />
  )
}

export default FacebookVideoFilesLibrary
